import {
    EnumActionEventCategory,
    getActionEventLabel,
    getBadgeVariantByCategory,
    getEnumActionEventCategoryLabel,
    type ApiActionEventLog,
} from '@Model';
import { Badge, Column } from '@synqo/frontend-component-library';

export const actionEventLogColumns: Column<ApiActionEventLog>[] = [
    { name: 'created_at', label: 'Zeitpunkt', type: 'datetime' },
    {
        name: 'category',
        label: 'Kategorie',
        renderCell: ({ cellData }) => {
            const category = cellData as EnumActionEventCategory;
            return (
                <Badge variant={getBadgeVariantByCategory(category)}>{getEnumActionEventCategoryLabel(category)}</Badge>
            );
        },
    },
    {
        name: 'action',
        label: 'Aktion',
        renderCell: ({ cellData }) => getActionEventLabel(cellData as string),
    },
    { name: 'related_object_resource_name', label: 'Ressourcentyp' },
    { name: 'related_object_display_string', label: 'Bezugsobjekt' },
    { name: 'remarks', label: 'Bemerkung' },
];
